import { Component, inject } from '@angular/core'
import { ModalHeaderComponent } from '../modal-header/modal-header.component'
import { ModalBodyComponent } from '../modal-body/modal-body.component'
import { ModalFooterComponent } from '../modal-footer/modal-footer.component'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ActiveFilterListComponent } from '../../table/filters/active-filter-list/active-filter-list.component'
import { EntitySelectorComponent } from '../../entity-selector/entity-selector.component'
import { EntityRef } from 'src/app/shared/models/referenceData'
import { LabeledPropertyComponent } from '../../labeled-property/labeled-property.component'
import { Subscription } from 'rxjs'
import { FilterService, Filter } from 'src/app/shared/services/filter/filter.service'
import { EntityFilter } from 'src/app/shared/services/filter/entity-filter'
import { HeaderModal } from '../../table/headers/table-header.component'

@Component({
  imports: [
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    LabeledPropertyComponent,
    EntitySelectorComponent,
    ActiveFilterListComponent,
  ],
  selector: 'app-entity-filter-modal',
  styles: `
  `,
  template: `
  @if(filter) {
    <div app-modal-header>{{ filter.state.config.meta.fieldDisplay }}</div>
    <div app-modal-body>
        <p>Select a filter values for the column {{ filter.state.config.meta.fieldDisplay }} below</p>
        <div app-labeled-property [label]="filter.state.config.meta.fieldDisplay">
            <div
              app-entity-selector
              (valueChange)="select($event)"
              [selectedEntities]="filter.state.entities"
              [config]="filter.state.config"
              [slim]="true"
            ></div>
        </div>
        <app-active-filter-list
          [filterGroup]="filter.state.config.meta.fieldGroup"
          [filterName]="filter.state.config.meta.fieldGroup"
        ></app-active-filter-list>
    </div>
    <div app-modal-footer>
        <button class="action-btn" (click)="onClose()">Close</button>
    </div>
  }
  `,
})
export class EntityFilterModalComponent implements HeaderModal {
  private modal = inject(NgbActiveModal)
  public filterService = inject(FilterService)

  private subscription = new Subscription()
  public filter: EntityFilter | undefined

  public init(
    fieldGroup: string,
    fieldName: string,
  ): void {
    this.subscription.add(
      this.filterService.state(fieldGroup).subscribe((group) => {
        const filter = group[fieldName] as Filter | undefined
        if(filter?.type === 'ENTITY') {
          this.filter = filter
        }
      }),
    )
  }

  select(entity: EntityRef) {
    if(this.filter) {
      this.filterService.dispatch(
        EntityFilter.AddEntityRefsAction({
          entities: [entity],
        },
        this.filter.state.config.meta),
      )
    }
  }

  onClose() {
    this.modal.close()
  }
}
